<template>
  <svg
    :width="props.size"
    :height="props.size"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 16.5H1.5V1.5H3V16.5ZM16.5 5.25H4.5V7.5H16.5V5.25ZM12 10.5H4.5V12.75H12V10.5Z"
      :fill="color"
    />
  </svg>
</template>

<script setup lang="ts">
  const props = defineProps({
    color: {
      type: String,
      default: '#0000FF',
    },
    size: {
      type: Number,
      default: 18,
    },
  })
</script>
